import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InsMenu from "../InsMenu/InsMenu";
import "./InsHeader.scss";
import images from "../../ressources/images";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { XHRImage as Image } from "../Media/Image";
import Notifications from "../Notifications/Notifications";
import { AnimatePresence } from "framer-motion";
import LogoCustomTheme from "../Theme/Logo/LogoCustomTheme";

const InsHeader = () => {
  const { t } = useTranslation();
  const [isMenuVisible, setisMenuVisible] = useState(false);
  const [areNotificationsVisible, setareNotificationslVisible] =
    useState(false);

  const openMenu = () => setisMenuVisible(true);
  const closeMenu = () => setisMenuVisible(false);

  const toggleNotifications = () =>
    setareNotificationslVisible((state) => !state);
  const openNotifications = () => setareNotificationslVisible(true);
  const closeNotifications = () => setareNotificationslVisible(false);

  const notifications = useSelector((state) => state.notifications);
  const account = useSelector((state) => state.account);
  const config = useSelector((state) => state.config);
  
  useEffect(() => {
    if (navigator?.setAppBadge) {
      navigator.setAppBadge(notifications?.notificationsNotSeen);
    }
  }, [notifications]);

  return (
    <div className="header">
      <header className={`ins_header`}>
        <div className="left_part">
          <div className={"menu " + isMenuVisible} onClick={openMenu}>
            <div className="menu--line"></div>
            <div className="menu--line"></div>
            <div className="menu--line"></div>
          </div>

          <div className="notifications" onClick={toggleNotifications}>
            {notifications.notificationsNotSeen > 0 ? (
              <div className="notifications_nbr">
                {notifications.notificationsNotSeen}
              </div>
            ) : null}
          </div>
        </div>
        <div className="middle_part">
          <Link to="/">
            <LogoCustomTheme className="logo" differentLogo={true} />
          </Link>
        </div>
        <div className="right_part">
          <div className="points">
            <div className="nbr_points">
              {account.points != null ? account.points : 0}
            </div>
            <div className="txt_points">{t("points")}</div>
          </div>
          <Link to="/profile">
            <div className="avatar">
              {account.picture ? (
                <Image src={account.picture} alt="" />
              ) : (
                <img src={images.icon_user} alt="" />
              )}
            </div>
          </Link>
        </div>
      </header>
      <div className="fix_height_header"></div>
      <InsMenu
        open={isMenuVisible}
        close={closeMenu}
        sap={true}
        hideMyOrders={config.management.hide_my_orders}
      />
      <AnimatePresence>
        {areNotificationsVisible && (
          <Notifications onClose={closeNotifications} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default InsHeader;
